module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"invite_new_member":"Invite New Member"},"id":{"invite_new_member":"Undang Member Baru"}}')
  delete Component.options._Ctor
}
